import { render } from "../../../public/privacy-policy.html?vue&type=template&id=0e482c8c"
import script from "./PrivacyPolicy.ts?vue&type=script&lang=js"
export * from "./PrivacyPolicy.ts?vue&type=script&lang=js"

import exportComponent from "/Users/r.hutter/Resilio Sync/_Workspace/git/TitleTool-NG/titletool-nextgen-server/titletool-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__